import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// TODO: Make pages scroll to html element when element id specified at url end
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}